import styled from 'styled-components';
import { colour, Heading1, Heading2, Heading3, Heading4, spacing } from '../../../../theme';

export const PaymentContainer = styled.div`
    display: block;
`;

export const Block = styled.div`
    display: block;
`;

export const PaymentHeader = styled.div`
    display: flex;
    justify-content: space-between;
    background-color: ${colour.palette.greyscale5};
    padding: ${spacing.spacing4} ${spacing.spacing2} ${spacing.spacing2} ${spacing.spacing3};
`;

export const FineDetails = styled.div`
    display: flex;
    justify-content: space-between;
    margin: ${spacing.spacing3} ${spacing.spacing2} ${spacing.spacing3} ${spacing.spacing3};
`;

export const StyledLine = styled.hr`
    border: 1px solid ${colour.palette.greyscale5};
    margin-top: ${spacing.spacing4};
    margin-bottom: ${spacing.spacing4};
    padding: ${spacing.spacing0};
`;

export const OrderSummaryText = styled.p`
    font-size: inherit;
    line-height: 1.6;
    text-rendering: optimizeLegibility;
    margin: ${spacing.spacing2} ${spacing.spacing0} ${spacing.spacing2} ${spacing.spacing0};

    & + ul {
        margin-top: -${spacing.spacing3};
    }

    & + ${Heading1}, & + ${Heading2}, & + ${Heading3}, & + ${Heading4} {
        margin-top: ${spacing.spacing6};
    }
`;

export const StyledTotalLine = styled.hr`
    border: 1px solid black;
    margin-top: ${spacing.spacing2};
    margin-bottom: ${spacing.spacing2};
    padding: ${spacing.spacing0};
`;
